'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _isFunction = require('lodash/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GATracking = function (_PureComponent) {
    _inherits(GATracking, _PureComponent);

    function GATracking() {
        _classCallCheck(this, GATracking);

        var _this = _possibleConstructorReturn(this, (GATracking.__proto__ || Object.getPrototypeOf(GATracking)).apply(this, arguments));

        _this.sendGaEvent = function (options) {
            var _this$props = _this.props,
                category = _this$props.category,
                nonInteraction = _this$props.nonInteraction;
            var _options$action = options.action,
                action = _options$action === undefined ? '' : _options$action,
                _options$label = options.label,
                label = _options$label === undefined ? '' : _options$label,
                _options$value = options.value,
                value = _options$value === undefined ? 0 : _options$value;

            if ((0, _isFunction2.default)(window.ga)) {
                window.ga('send', 'event', '' + category, '' + action, '' + label, Number(value), { nonInteraction: nonInteraction });
            } else {
                console.error('GA not loaded');
            }
        };
        return _this;
    }

    _createClass(GATracking, [{
        key: 'render',
        value: function render() {
            // eslint-disable-next-line react/destructuring-assignment
            if ((0, _isFunction2.default)(this.props.children)) {
                // eslint-disable-next-line react/destructuring-assignment
                return this.props.children(this.sendGaEvent);
            }
            throw new Error('"children" needs to be a function');
        }
    }]);

    return GATracking;
}(_react.PureComponent);

exports.default = GATracking;

GATracking.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired,
    nonInteraction: _propTypes2.default.bool,
    category: _propTypes2.default.string.isRequired
};
GATracking.defaultProps = {
    nonInteraction: true
};
//# sourceMappingURL=GATracking.js.map